import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialSection() {
  return <section className="py-24 relative bg-brand-darker border-y border-white/5 pt-[10px] pb-[10px]" data-id="element-160">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative p-8 md:p-12 rounded-2xl border border-white/10 bg-brand-black overflow-hidden" data-id="element-162">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-brand-gold to-transparent opacity-50" data-id="element-163" />

          <Quote className="w-12 h-12 text-brand-gold/20 mb-6" data-id="element-164" />

          <p className="text-xl md:text-2xl text-brand-white font-light italic leading-relaxed mb-8" data-id="element-165">
            "Pasé de revisar su perfil cada 10 minutos a sentir una indiferencia
            real en menos de un mes. El árbol de decisiones me salvó de volver a
            humillarme cuando me escribió llorando."
          </p>

          <div className="flex items-center gap-2 mb-4 text-brand-gold" data-id="element-166">
            {'★★★★★'.split('').map((star, i) => <span key={i} className="text-lg" data-id="element-167">
                {star}
              </span>)}
          </div>

          <div className="flex items-center gap-4" data-id="element-168">
            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face" alt="Carolina M." className="w-12 h-12 rounded-full object-cover border-2 border-brand-gold/30" data-id="element-169" />
            <div data-id="element-170">
              <div className="flex items-center gap-2" data-id="element-171">
                <p className="text-brand-white font-semibold" data-id="element-172">Carolina M.</p>
                <span className="text-xs bg-brand-green/20 text-brand-green px-2 py-0.5 rounded-full font-medium" data-id="element-173">
                  ✓ Verificado
                </span>
              </div>
              <p className="text-brand-gray text-sm" data-id="element-174">
                28 años · Ciudad de México · Recuperó su centro en 21 días
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}